import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the form state domain
 */

const selectFormDomain = (state) =>
  state.get("AdministratorCompaniesForm", initialState)

/**
 * Other specific selectors
 */

export const makeSelectOptions = () =>
  createSelector(selectFormDomain, (state) => state.get("options"))

export const makeSelectOptionsLoading = () =>
  createSelector(selectFormDomain, (state) => state.get("optionsLoading"))

export const makeSelectSaveLoading = () =>
  createSelector(selectFormDomain, (state) => state.get("saveLoading"))

export const makeSelectCurrentCompanyLoading = () =>
  createSelector(selectFormDomain, (state) =>
    state.get("currentCompanyLoading")
  )

export const makeSelectCurrentCompany = () =>
  createSelector(selectFormDomain, (state) => state.get("currentCompany"))

export const makeSelectDeleteLoading = () =>
  createSelector(selectFormDomain, (state) => state.get("deleteLoading"))

export const makeSelectUsersLoading = () =>
  createSelector(selectFormDomain, (state) => state.get("usersLoading"))

export const makeSelectUserSASwitch = () =>
  createSelector(selectFormDomain, (state) => state.get("userSASwitch"))

export const makeSelectUsers = () =>
  createSelector(selectFormDomain, (state) => state.get("users"))
export const makeSelectCurrentUsers = () =>
  createSelector(selectFormDomain, (state) => state.get("currentUsers"))

export const makeSelectValidateVismaPeopleInfo = () => createSelector(selectFormDomain, (state) => state.get("validateVismaPeopleInfo"))
export const makeSelectValidateVismaPeopleInfoLoading = () => createSelector(selectFormDomain, (state) => state.get("validateVismaPeopleInfoLoading"))
export const makeSelectValidateVismaPeopleInfoRequested = () => createSelector(selectFormDomain, (state) => state.get("validateVismaPeopleInfoRequested"))

export const makeSelectValidateVismaPeopleStructure = () => createSelector(selectFormDomain, (state) => state.get("validateVismaPeopleStructure"))  
export const makeSelectValidateVismaPeopleStructureLoading = () => createSelector(selectFormDomain, (state) => state.get("validateVismaPeopleStructureLoading"))
export const makeSelectValidateVismaPeopleStructureFeedback = () => createSelector(selectFormDomain, (state) => state.get("validateVismaPeopleStructureFeedback"))
export const makeSelectValidateVismaPeopleStructureRequested = () => createSelector(selectFormDomain, (state) => state.get("validateVismaPeopleStructureRequested"))
/**
 * Default selector used by Form
 */

const makeSelectForm = () =>
  createSelector(selectFormDomain, (substate) => substate.toJS())

export default makeSelectForm
export { selectFormDomain }
